import React, { useState, useEffect, useCallback, Suspense, useRef } from 'react';
import {
  Tooltip,
  Row,
  Button,
  Table,
  Col,
  Form,
  ConfigProvider,
  Tag,
  Select,
  Dropdown,
  Popconfirm,
  notification,
  Input,
  Checkbox,
  Menu,
  Image,
  Modal,
} from 'antd';
import { getShipmentTypes, getStores } from 'store/requests/definitions';
import trTR from 'antd/es/locale/tr_TR';
import { useTranslation } from 'react-i18next';
import {
  CSV_EXPORT_COLUMNS,
  AUTH_ROLE_CAN_APPROVE,
  DateFormat,
  debouncedDataLoadWaitMs,
  ORDER_TYPES,
  STATUS,
  ZONE_APPROVAL_STATUS,
  ZONE_TYPE,
  ERROR_CODES,
  CHANNEL
} from 'helpers/constants';
import debounce from 'lodash/debounce';
import { connect, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import {
  FilterOutlined,
  PlusOutlined,
  DownloadOutlined,
  DownCircleOutlined,
  UpCircleOutlined,
  CheckOutlined,
  CloseOutlined,
  EditOutlined,
  MoreOutlined,
  RollbackOutlined,
  SwapOutlined,
  ClearOutlined,
  TableOutlined,
  GatewayOutlined,
  ArrowRightOutlined,
} from '@ant-design/icons';
import userHaveRolePermission from 'helpers/userHaveRolePermission';
import { PAGE_URLS, PARENT_ROUTES } from 'helpers/endpoints';
import MapOperations from './MapOperations';
import 'styles/custom/zone.less';
import moment from 'moment';
import {
  addZoneAction,
  cancelZoneAction,
  cityLocalBoundaries,
  districtLocalBoundaries,
  editZoneAction,
  filterZoneAction,
  geoRadarApprove,
  getGeoRadarZoneHistory,
  getGeoRadarZones,
  getGeoRadarZoneTypes,
  getNeighborhoodBoundariesByRegion,
  setActiveExpZoneRow,
  setSelectedVersionRows,
  versionZoneEditAction,
  openHeatmap,
  closeHeatmap,
  getAllGeoRadarZones,
  geoRadarZoneRevert,
  visibleCleanAndResetButton,
  getRivalsByLocation,
  setStoreLocationsLatLng,
  getAllZonesNearbySelectedZone,
  setCitySelection,
  setDistrictSelected,
  setNeighborhoodSelected,
  setSlotsFromZone,
} from '../../../store/requests/zone';
import SelectRegionsAndStores from './SelectRegionsAndStores';
import { CityDistrictAndNeighborhoodSelection } from './CityDistrictAndNeighborhoodSelection';
import OrderHeatmapLayer from './OrderHeatmapLayer';
import { getZonesByStoreIdForSlots } from 'store/requests/slot';
import GenerateSlot from './GenerateSlot';
import { CSVLink } from 'react-csv';
const ZonesTableFilters = React.lazy(() => import('./ZonesTableFilters'));
const Add = React.lazy(() => import('./Add'));
const Edit = React.lazy(() => import('./Edit'));
const VersionEdit = React.lazy(() => import('./VersionEdit'));
const ZoneMoveModal = React.lazy(() => import('./ZoneMoveModal'));
let lastQuery = false;

const { Option } = Select;
const { Search } = Input;
const Zones = ({ route }) => {
  const csvLink = useRef();
  const [downloadedData, setDownloadedData] = useState([]);
  const history = useHistory();
  const { isViewEnabled, isDrawingEnabled, isApprovalEnabled, isCrudEnabled } =
    userHaveRolePermission(route?.name);
  if (!isViewEnabled) {
    history.push(`${PAGE_URLS.AUTH}${PAGE_URLS.CONTROL}`);
  }
  const { t } = useTranslation();
  const zoneState = useSelector((state) => state?.zone?.geoRadarZone) ?? null;
  const userRoles = useSelector((state) => state.auth.userIntrospect.roles);
  const rivalsByLocationState =
    useSelector((state) => state?.zone?.rivalsByLocation) ?? null;
  const {
    storeLocationsLatLng,
    selectedCity,
    selectedDistrict,
    selectedNeighborhood,
  } =
    useSelector((state) => state?.zone?.cityDistrictAndNeighborhoodSelection) ??
    null;
  const [form] = Form.useForm();
  const [heatmapForm] = Form.useForm();
  const [geoRadarZones, setGeoRadarZones] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState({});
  const [zoneTypes, setZoneTypes] = useState([]);
  const [
    selectedRowsForVersionHistoryTable,
    setSelectedRowsForVersionHistoryTable,
  ] = useState(null);
  const [refreshMap, setRefreshMap] = useState(false);
  const [zoneVersionData, setZoneVersionData] = useState({
    versionsData: [],
    zoneId: null,
  });
  const [customerLocation, setCustomerLocation] = useState(null);
  const [heatmapModalOpen, setHeatmapModalOpen] = useState(false);
  const [heatmapChecked, setHeatmapChecked] = useState(false);
  const [zoneMoveModalConfig, setZoneMoveModalConfig] = useState({
    visible: false,
    selectedZone: null,
  });
  const [isHaveCentralRole, setIsHaveCentralRole] = useState(false);
  const [shipmentTypes, setShipmentTypes] = useState([]);
  const [rivalsLoading, setRivalsLoading] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [generateSlot, setGenerateSlot] = useState(false);
  const [dataItemForSlots, setDataItemForSlots] = useState(null);
  const [selectedRegionsAndStoresConfig, setSelectedRegionsAndStoresConfig] =
    useState({
      selectedRegions: [],
      selectedStores: [],
      stores: [],
      selectAllRegions: false,
    });
  const [
    selectedCityDistrictOrNeighborhoodConfig,
    setSelectedCityDistrictOrNeighborhoodConfig,
  ] = useState({
    neighborHoodBoundaries: [],
    districtBoundaries: [],
    cityBoundaries: [],
  });
  const [exportButtonLoading, setExportButtonLoading] = useState(false);
  const [collapsed, setCollapsed] = useState(true);
  const versionStatus = {
    APPROVED: (
      <span style={{ color: '#2AB514' }}>
        {t(ZONE_APPROVAL_STATUS.APPROVED)}
      </span>
    ),
    NOT_APPROVED: (
      <span style={{ color: '#FB0A0A' }}>
        {t(ZONE_APPROVAL_STATUS.NOT_APPROVED)}
      </span>
    ),
    WAITING_FOR_APPROVAL: (
      <span style={{ color: '#FD9904' }}>
        {t(ZONE_APPROVAL_STATUS.WAITING_FOR_APPROVAL)}
      </span>
    ),
    NEW: (
      <span style={{ color: '#1337B6' }}>{t(ZONE_APPROVAL_STATUS.NEW)}</span>
    ),
    CANCELLED: (
      <span style={{ color: '#900000' }}>
        {t(ZONE_APPROVAL_STATUS.CANCELLED)}
      </span>
    ),
    HAS_NEW_VERSION_FOR_APPROVAL: (
      <span style={{ color: '#a51aff' }}>
        {t(ZONE_APPROVAL_STATUS.HAS_NEW_VERSION_FOR_APPROVAL)}
      </span>
    ),
  };

  useEffect(() => {
    if (userRoles && userRoles.length > 0) {
      if (
        userRoles.includes(AUTH_ROLE_CAN_APPROVE.CENTRAL_OPERATIONS_EXECUTIVE)
      ) {
        setIsHaveCentralRole(true);
      }
    }
  }, [userRoles]);

  const fetchCSVData = async () => {
    setExportButtonLoading(true);
    try {
      const getAllGeoRadarZonesResponse = await getAllGeoRadarZones();
      const zonesData = getAllGeoRadarZonesResponse.data;

      if (zonesData && zonesData.length > 0) {
        const csvData = [
          CSV_EXPORT_COLUMNS.map((item) => t(item)),
          ...zonesData.map((item) => [
            item.zoneCode,
            item.zoneName,
            item.areaKm,
            item.storeCode,
            item.storeName,
            item.cityName,
            item.districtName,
            t(item.zoneType),
            t(item.zoneStatus),
            item.ovenAvailable === null
              ? '-'
              : item.ovenAvailable
                ? t('hasYes')
                : t('hasNo'),
            item.note,
            t(item.main),
            item.priority,
            item.zoneWithShipmentTypes.length > 0
              ? getZoneWithShipmentTypes(item.zoneWithShipmentTypes)
              : '',
          ]),
        ];
        setDownloadedData(csvData);
        csvLink.current.link.click();
      }
    } finally {
      setExportButtonLoading(false);
    }
  };

  const getZoneWithShipmentTypes = (zoneWithShipmentTypes) => zoneWithShipmentTypes
    .map((item) => item.shipmentType.replace(',', ';'))
    .join(' - ');

  const toggleCollapsed = () => {
    setCollapsed(!collapsed);
  };

  const [tableParams, setTableParams] = useState({
    pagination: {
      showSizeChanger: true,
      showQuickJumper: true,
      showTotal: (total) => `Toplam ${total} kayıt`,
      pageSizeOptions: [300, 500, 1000],
      size: 'small',
      current: 1,
      pageSize: 300,
    },
  });

  useEffect(() => {
    async function loadData() {
      setLoading(true);
      const zoneTypesResponse = await getGeoRadarZoneTypes();
      setZoneTypes(zoneTypesResponse.data);
      const getShipmentTypesRes = await getShipmentTypes();
      setShipmentTypes(getShipmentTypesRes?.items || []);
      setLoading(false);
    }
    loadData();
  }, []);

  useEffect(() => {
    setGeoRadarZones([]);
    setSelectedCityDistrictOrNeighborhoodConfig({
      cityBoundaries: [],
      districtBoundaries: [],
      neighborHoodBoundaries: [],
    });
    setSelectedRowsForVersionHistoryTable([]);

    setCitySelection(false);
    setDistrictSelected(false);
    setNeighborhoodSelected(false);

    if (
      selectedRegionsAndStoresConfig?.selectedRegions.length > 0 ||
      selectedRegionsAndStoresConfig?.selectedStores.length > 0 ||
      selectedRegionsAndStoresConfig?.selectAllRegions
    ) {
      fetchData();
      filterZoneAction(false);
      return () => {
        lastQuery = null;
        setLoading(false);
      };
    } else {
      setGeoRadarZones([]);
      setSelectedCityDistrictOrNeighborhoodConfig({
        cityBoundaries: [],
        districtBoundaries: [],
        neighborHoodBoundaries: [],
      });
      setSelectedRowsForVersionHistoryTable([]);
    }
  }, [
    tableParams.pagination.current,
    tableParams.pagination.pageSize,
    tableParams.column?.dataIndex,
    tableParams.order,
    JSON.stringify(filters),
    selectedRegionsAndStoresConfig?.selectedRegions,
    selectedRegionsAndStoresConfig?.selectedStores,
    selectedRegionsAndStoresConfig?.selectAllRegions,
  ]);

  const fetchData = () => {
    cancelZoneAction();
    const queryString = getQueryString();
    loadData(queryString);
  };

  const zoneRevert = (zoneId) => {
    setLoading(true);
    geoRadarZoneRevert(zoneId, { zoneActionConfirmed: false })
      .then((res) => {
        if (res) {
          setLoading(false);
          notificationSave(STATUS.SUCCESS);
          fetchData();
        }
      })
      .catch((error) => {
        if (error.status && error.status === 400) {
          const errorCode = error.errorCode;
          const errorMessage = error.message;

          if (errorCode === ERROR_CODES.GRDR_1008) {
            Modal.confirm({
              title: t('doYouConfirm'),
              content: errorMessage,
              onOk: () => {
                setLoading(true);
                geoRadarZoneRevert(zoneId, { zoneActionConfirmed: true })
                  .then((res) => {
                    if (res) {
                      setTimeout(() => {
                        setLoading(false);
                        notificationSave(STATUS.SUCCESS);
                        fetchData();
                      }, 500);
                    }
                  })
                  .finally(() => {
                    setLoading(false);
                  });
              },
              onCancel: () => {},
            });
          }
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleTableChange = (pagination, filters, sorter) => {
    setTableParams({
      pagination,
      ...sorter,
    });
  };

  const columns = [
    {
      title: t('store'),
      dataIndex: 'store.code',
      sorter: true,
      showSorterTooltip: false,
      render: (item, data) =>
        data?.store ? <p style={{ margin: 0 }}>{`${data.store.code}-${data.store.name}`}</p> : '--',
    },
    {
      title: t('zone'),
      dataIndex: 'code',
      sorter: true,
      showSorterTooltip: false,
      render: (name, data) =>
        data.name ? <p style={{ margin: 0 }}>{`${data.code}-${data.name}`}</p> : '--',
    },
    {
      title: t('zoneManagement.zoneType'),
      dataIndex: 'type',
      sorter: true,
      showSorterTooltip: false,
      render: (item) => (item ? <p>{t(item)}</p> : '--'),
    },
    {
      title: t('isActive'),
      dataIndex: 'isActive',
      sorter: (a, b) => a.isActive - b.isActive,
      showSorterTooltip: false,
      render: (isActive, data) => (
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          {isActive ? (
            <Tag color={'#2AB514'}>{t('active')}</Tag>
          ) : (
            <Tag color={'#FB0A0A'}>{t('passive')}</Tag>
          )}
          {data?.moveSourceId && data?.isActive && isCrudEnabled && !(data.store.channel === CHANNEL.TRANSFORMATION) && (
            <Popconfirm
              title={t('zoneRevertMessage')}
              onConfirm={() => zoneRevert(data.id)}
              okText={t('zoneRevert')}
              cancelText={t('cancel')}
            >
              <RollbackOutlined style={{ fontSize: '20px', color: '#08c' }} />
            </Popconfirm>
          )}
        </div>
      ),
    },
    {
      title: t('deliveryFee'),
      dataIndex: 'deliveryFee',
      sorter: true,
      showSorterTooltip: false,
      render: (deliveryFee) => deliveryFee ?? '--',
    },
    {
      title: t('isOvenAvailable'),
      dataIndex: 'isOvenAvailable',
      sorter: true,
      showSorterTooltip: false,
      render: (isOvenAvailable) =>
        isOvenAvailable === null
          ? '--'
          : isOvenAvailable
            ? t('hasYes')
            : t('hasNo'),
    },
    {
      title: t('zoneManagement.approvalStatus'),
      dataIndex: 'versionApprovalStatus',
      sorter: true,
      showSorterTooltip: false,
      render: (versionApprovalStatus) =>
        versionStatus[versionApprovalStatus] ?? '--',
    },
    {
      title: '',
      dataIndex: 'mainZone',
      sorter: false,
      showSorterTooltip: false,
      width: '25px',
      render: (text, record) => (
        <>
          {record.main && (
            <Tooltip title={t('mainZone')}>
              <Image
                src="/static/img/mainZone.svg"
                width={15}
                height={15}
                preview={false}
              />
            </Tooltip>
          )}
        </>
      ),
    },
    {
      width: 50,
      render: (dataItem) =>
        isDrawingEnabled &&
        ![
          ZONE_APPROVAL_STATUS.WAITING_FOR_APPROVAL,
          ZONE_APPROVAL_STATUS.HAS_NEW_VERSION_FOR_APPROVAL,
        ].includes(dataItem.versionApprovalStatus) && (
          <Dropdown
            menu={{
              items: [
                {
                  label: t('edit'),
                  icon: <EditOutlined />,
                  onClick: () => {
                    editZoneAction(dataItem);
                    getAllZonesNearbySelectedZone(dataItem.id);
                  },
                },
                (
                  dataItem.type === ZONE_TYPE.ORDER_ZONE &&
                  isCrudEnabled &&
                  (
                    (!dataItem.moveSourceId && dataItem.store.channel !== CHANNEL.TRANSFORMATION) ||
                    dataItem.store.channel === CHANNEL.TRANSFORMATION
                  )
                ) && {
                    label: t('zoneMove'),
                    icon: <SwapOutlined />,
                    onClick: () => {
                      setZoneMoveModalConfig({
                        visible: true,
                        selectedZone: dataItem,
                      });
                    },
                  },
                {
                  label: t('goToSlots'),
                  icon: <ArrowRightOutlined />,
                  onClick: () => {
                    getZonesByStoreIdForSlots(
                      `filter=store.id==${dataItem?.store?.id}&size=2000`,
                    ).then((zones) => {
                      const { content } = zones ?? [];
                      setSlotsFromZone({
                        store: dataItem.store,
                        zone: dataItem,
                        zonesOfStore: content ?? [],
                      });
                      history.push(
                        `${PARENT_ROUTES.ZONE_MANAGEMENT}${PAGE_URLS.SLOT_MONITORING}`,
                      );
                    });
                  },
                },
                dataItem.isActive && {
                    label: t('generateSlot'),
                    icon: <PlusOutlined />,
                    onClick: () => {
                      setGenerateSlot(true);
                      setDataItemForSlots(dataItem);
                    },
                  },
              ],
            }}
            placement="bottomRight"
            arrow
            trigger={['click']}
          >
            <Button shape="circle" icon={<MoreOutlined />}></Button>
          </Dropdown>
        ),
    },
  ];

  const actions = [
    {
      isDrawingEnabled,
      type: 'primary',
      title: t('add'),
      icon: <PlusOutlined />,
      onClick: () => {
        addZoneAction();
        setCollapsed(true);
      },
      disabled: !selectedRegionsAndStoresConfig?.selectedRegions.length > 0,
    },
    {
      isCrudEnabled: true,
      type: '',
      title: t('download'),
      customContent: (
        <>
          <Button
            style={{ marginRight: '3px' }}
            shape="round"
            icon={<DownloadOutlined />}
            onClick={fetchCSVData}
            loading={exportButtonLoading}
          />
          <CSVLink
            filename={'Zones'}
            data={downloadedData}
            ref={csvLink}
            className="hidden"
            separator=";"
            uFEFF={true}
          />
        </>
      ),
      disabled: exportButtonLoading,
    },
    !zoneState?.isAddOpen &&
      !zoneState?.isEditOpen &&
      !zoneState?.isFiltersOpen && {
        isCrudEnabled: true,
        type: 'primary',
        title: collapsed ? t('expandMap') : t('showList'),
        onClick: () => {
          toggleCollapsed();
        },
        icon: collapsed ? <GatewayOutlined /> : <TableOutlined />,
      },
  ];

  const renderSelectedFilters = () => {
    return Object.keys(filters).map((item, idx) => {
      if (filters[item] !== null && filters[item] !== undefined) {
        return (
          <Tag
            key={idx}
            closable
            color="geekblue"
            onClose={(e) => {
              e.preventDefault();
              removeItemFromFilters(item);
            }}
          >
            {`${t(item)} : ${t(filters[item])}`}
          </Tag>
        );
      }
    });
  };

  const removeItemFromFilters = (destinationItem) => {
    Object.keys(filters).forEach((item) => {
      if (item === destinationItem) {
        const editedFilters = {
          ...filters,
          [destinationItem]: undefined,
        };
        setFilters(editedFilters);
        form.setFieldsValue(editedFilters);
      }
    });
  };

  const renderActionButtons = () => {
    return actions.map((item, idx) => {
      return (
        <Tooltip title={item.title} key={idx}>
          {(item.isDrawingEnabled || item.isCrudEnabled) &&
            (item.customContent ?? (
              <Button
                type={item?.type}
                shape="round"
                icon={item?.icon}
                onClick={item.onClick}
                disabled={item.disabled}
                style={{ marginBottom: '10px', marginRight: '3px' }}
                danger={item?.danger}
                loading={item.loading}
              />
            ))}
        </Tooltip>
      );
    });
  };

  const getQueryString = () => {
    let queryString = '';
    let defaultIsActiveSort = true;
    const selectedRegionIds =
      selectedRegionsAndStoresConfig?.selectedRegions?.map((region) =>
        region.value ? region.value : region,
      );
    const selectedStoreIds =
      selectedRegionsAndStoresConfig?.selectedStores?.map(
        (store) => store.value ?? store,
      );
    selectedRegionsAndStoresConfig?.selectedStores.length > 0
      ? (queryString += `filter=store.id=in=(${selectedStoreIds})`)
      : selectedRegionsAndStoresConfig?.selectAllRegions
        ? (queryString += `filter=store.region.country.id==1`)
        : selectedRegionIds.length > 0
          ? (queryString += `filter=store.region.id=in=(${selectedRegionIds})`)
          : (queryString += '');

    Object.keys(filters).forEach((item, idx) => {
      if (filters[item] !== null && filters[item] !== undefined) {
        queryString += ` and ${encodeURI(item)}=='${encodeURI(filters[item])}'`;
      }
    });

    queryString = `${queryString}&page=${tableParams.pagination.current - 1}&size=${tableParams.pagination.pageSize}`;
    if (tableParams.column) {
      queryString += `&sort=${
        tableParams.column.dataIndex === 'isActive'
          ? 'active'
          : tableParams.column.dataIndex
      },${ORDER_TYPES[tableParams.order]}`;
      defaultIsActiveSort = false;
    }

    if (defaultIsActiveSort) {
      queryString += '&sort=active,desc';
    }

    queryString = queryString.trim();

    return queryString;
  };

  async function loadDataWithDebounce(queryString) {
    lastQuery = queryString;
    setLoading(true);
    getGeoRadarZones(queryString)
      .then((zone) => {
        const { content, page } = zone;
        setGeoRadarZones(content ?? []);
        setTableParams({
          ...tableParams,
          pagination: {
            ...tableParams.pagination,
            total: page?.totalElements,
          },
        });
      })
      .finally(() => setLoading(false));
  }

  const loadData = useCallback(
    debounce((queryString) => {
      loadDataWithDebounce(queryString);
    }, debouncedDataLoadWaitMs),
  );

  const rowSelection = {
    selectedRowKeys,
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedVersionRows(selectedRows);
      setSelectedRowKeys(selectedRowKeys);
    },
  };

  const rowSelectionForVersionHistoryTable = {
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedRowsForVersionHistoryTable(selectedRows);
    },
  };

  useEffect(() => {
    if (
      selectedRegionsAndStoresConfig.selectedRegions.length > 0 &&
      selectedRegionsAndStoresConfig.selectedStores.length === 0 &&
      !selectedRegionsAndStoresConfig.selectAllRegions
    ) {
      (async () => {
        const regionIds = selectedRegionsAndStoresConfig?.selectedRegions.map(
          (region) => (region?.value ? region?.value : region),
        );
        getStores(`filter=region.id=in=(${regionIds})&size=1000`).then(
          (storeInfo) => {
            let locations =
              storeInfo?._embedded?.storeResponseDtoList?.map((store) => ({
                latitude: store.latitude,
                longitude: store.longitude,
              })) || [];
            setStoreLocationsLatLng(locations);
          },
        );
      })();
    } else {
      setGeoRadarZones([]);
      setSelectedCityDistrictOrNeighborhoodConfig({
        cityBoundaries: [],
        districtBoundaries: [],
        neighborHoodBoundaries: [],
      });
      setSelectedRowsForVersionHistoryTable([]);
    }
  }, [
    selectedRegionsAndStoresConfig.selectedRegions,
    selectedRegionsAndStoresConfig.selectedStores,
  ]);

  useEffect(() => {
    (async () => {
      if (selectedCity && storeLocationsLatLng.length > 0) {
        cityLocalBoundaries({ locations: storeLocationsLatLng }).then(
          (cityRes) => {
            setSelectedCityDistrictOrNeighborhoodConfig((prevState) => ({
              ...prevState,
              cityBoundaries: cityRes.data ?? [],
            }));
          },
        );
      } else {
        setSelectedCityDistrictOrNeighborhoodConfig((prevState) => ({
          ...prevState,
          cityBoundaries: [],
        }));
      }
    })();
  }, [selectedCity, storeLocationsLatLng]);

  useEffect(() => {
    (async () => {
      if (selectedDistrict && storeLocationsLatLng.length > 0) {
        districtLocalBoundaries({ locations: storeLocationsLatLng }).then(
          (districtRes) => {
            setSelectedCityDistrictOrNeighborhoodConfig((prevState) => ({
              ...prevState,
              districtBoundaries: districtRes.data ?? [],
            }));
          },
        );
      } else {
        setSelectedCityDistrictOrNeighborhoodConfig((prevState) => ({
          ...prevState,
          districtBoundaries: [],
        }));
      }
    })();
  }, [selectedDistrict, storeLocationsLatLng]);

  useEffect(() => {
    (async () => {
      if (selectedNeighborhood && storeLocationsLatLng.length > 0) {
        const regionIds = selectedRegionsAndStoresConfig?.selectedRegions.map(
          (region) => region?.value,
        );
        getNeighborhoodBoundariesByRegion(regionIds).then((neighborhoodRes) => {
          setSelectedCityDistrictOrNeighborhoodConfig((prevState) => ({
            ...prevState,
            neighborHoodBoundaries: neighborhoodRes.data ?? [],
          }));
        });
      } else {
        setSelectedCityDistrictOrNeighborhoodConfig((prevState) => ({
          ...prevState,
          neighborHoodBoundaries: [],
        }));
      }
    })();
  }, [selectedNeighborhood, storeLocationsLatLng]);

  const refreshMapAndTable = () => {
    fetchData();
    setRefreshMap(true);
  };

  const onSearch = (value) => {
    const [lat, lng] = value.split(',');
    const latLng = new window.google.maps.LatLng(
      parseFloat(lat),
      parseFloat(lng),
    );
    setCustomerLocation(latLng);
  };

  const notificationSave = (type) => {
    notification[type]({
      message: t('processCompleted'),
    });
  };
  const zoneVersionConfirm = (data) => {
    setLoading(true);
    geoRadarApprove(data)
      .then((res) => {
        if (res?.data?.isSuccess) {
          notificationSave(STATUS.SUCCESS);
          setLoading(false);
          fetchData();
        } else {
          notification[STATUS.ERROR]({
            description: data?.message,
          });
        }
      })
      .finally(() => {
        setLoading(false);
        cancelZoneAction();
      });
  };

  const onChangeHeatmapCheckbox = (event) => {
    const isChecked = event.target.checked;
    setHeatmapChecked(isChecked);
    isChecked ? openHeatmap() : closeHeatmap();
    setHeatmapModalOpen(isChecked);
    !isChecked && heatmapForm.resetFields(['date']);
  };

  const expandedRowRender = () => {
    const columns = [
      {
        title: t('zoneManagement.approvalStatus'),
        dataIndex: 'approvalStatus',
        key: 'approvalStatus',
        render: (approvalStatus) => versionStatus[approvalStatus] ?? '--',
      },
      {
        title: t('zoneManagement.updater'),
        dataIndex: 'createdBy',
        key: 'updater',
      },
      {
        title: t('zoneManagement.updatedDate'),
        dataIndex: 'modifiedAt',
        key: 'modifiedAt',
        render: (createdDate) =>
          moment(createdDate).format(DateFormat.WithHourDateFormat),
      },
      {
        title: t('zoneManagement.isInUse'),
        dataIndex: 'inUse',
        key: 'inUse',
        render: (inUse) =>
          inUse ? (
            <span>{t('zoneManagement.inUse')}</span>
          ) : (
            <span>{t('zoneManagement.notInUse')}</span>
          ),
      },
      {
        width: 50,
        render: (dataItem) =>
          dataItem.approvalStatus ===
            ZONE_APPROVAL_STATUS.WAITING_FOR_APPROVAL &&
          isApprovalEnabled && (
            <div style={{ display: 'flex', margin: '3px' }}>
              <Popconfirm
                title={t('zoneActiveQuestion')}
                onConfirm={() =>
                  zoneVersionConfirm({
                    isApproved: true,
                    id: zoneVersionData.zoneId,
                  })
                }
                okText={t('yes')}
                cancelText={t('no')}
              >
                <Button
                  type="primary"
                  style={{
                    backgroundColor: '#2AB514',
                    color: 'white',
                    border: 0,
                    marginRight: '3px',
                  }}
                  shape="circle"
                  icon={<CheckOutlined />}
                ></Button>
              </Popconfirm>
              <Popconfirm
                title={t('zonePassiveQuestion')}
                onConfirm={() =>
                  zoneVersionConfirm({
                    isApproved: false,
                    id: zoneVersionData.zoneId,
                  })
                }
                okText={t('yes')}
                cancelText={t('no')}
              >
                <Button
                  type="primary"
                  shape="circle"
                  style={{
                    backgroundColor: '#FB0A0A',
                    color: 'white',
                    border: 0,
                  }}
                  icon={<CloseOutlined />}
                ></Button>
              </Popconfirm>
            </div>
          ),
      },
      {
        width: 50,
        render: (dataItem) =>
          isDrawingEnabled &&
          ![
            ZONE_APPROVAL_STATUS.APPROVED,
            ZONE_APPROVAL_STATUS.CANCELLED,
            ZONE_APPROVAL_STATUS.NOT_APPROVED,
          ].includes(dataItem.approvalStatus) && (
            <Dropdown
              menu={{
                items: [
                  {
                    label: t('edit'),
                    icon: <EditOutlined />,
                    onClick: () => {
                      versionZoneEditAction(dataItem);
                    },
                  },
                ],
              }}
              placement="bottomRight"
              arrow
              trigger={['click']}
            >
              <Button shape="circle" icon={<MoreOutlined />}></Button>
            </Dropdown>
          ),
      },
    ];

    return (
      <Table
        columns={columns}
        dataSource={zoneVersionData?.versionsData.map((item, index) => ({
          ...item,
          key: index.toString(),
        }))}
        pagination={false}
        rowSelection={{
          ...rowSelectionForVersionHistoryTable,
          hideSelectAll: true,
        }}
      />
    );
  };

  return (
    <div style={{ position: 'relative' }}>
      {!zoneState?.isVersionEditOpen && (
        <>
          <Row
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'start',
            }}
          >
            <Col>{renderActionButtons()}</Col>
            <Col></Col>
            <Row
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'end',
                width: '50%',
              }}
            >
              <Col>
                <div style={{ display: 'flex', alignItems: ' center' }}>
                  <Checkbox
                    onChange={onChangeHeatmapCheckbox}
                    checked={heatmapChecked}
                  >
                    {t('heatmap')}
                  </Checkbox>
                  {zoneState?.heatmapDateRange && zoneState?.heatmapToggle && (
                    <Tag color="geekblue">
                      {`${zoneState?.heatmapDateRange.startDate}-${zoneState?.heatmapDateRange.finishDate}`}
                    </Tag>
                  )}
                  <Button
                    style={{ marginRight: '10px' }}
                    type="primary"
                    loading={rivalsLoading}
                    onClick={() => {
                      setRivalsLoading(true);
                      getRivalsByLocation().then(() => setRivalsLoading(false));
                    }}
                    disabled={
                      rivalsByLocationState?.getRivalsByLocationButtonChangeTitle
                    }
                  >
                    {!rivalsByLocationState?.getRivalsByLocationButtonChangeTitle
                      ? t('bringCompetitorStores')
                      : t('arrivedCompetitorStores')}
                  </Button>
                  {rivalsByLocationState?.showCleanAndResetButton && (
                    <Button
                      disabled={rivalsLoading}
                      onClick={() => visibleCleanAndResetButton(false)}
                      type="dashed"
                      shape="circle"
                      icon={<ClearOutlined />}
                    />
                  )}
                  {selectedRegionsAndStoresConfig?.selectedRegions.length > 0 &&
                    selectedRegionsAndStoresConfig.selectedStores.length ===
                    0 &&
                    !selectedRegionsAndStoresConfig.selectAllRegions && (
                      <CityDistrictAndNeighborhoodSelection />
                    )}
                </div>
              </Col>
              <Col>
                <Button
                  shape="round"
                  icon={<FilterOutlined />}
                  onClick={() => filterZoneAction(!zoneState?.isFiltersOpen)}
                >
                  {t('filters')}
                </Button>
              </Col>
            </Row>
          </Row>
          <Row style={{ display: 'flex', justifyContent: 'flex-end' }}>
            {renderSelectedFilters()}
          </Row>
        </>
      )}
      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Suspense fallback={<></>}>
          {zoneState?.isVersionEditOpen && (
            <Col>
              <VersionEdit
                isHaveCentralRole={isHaveCentralRole}
                onSuccessCallback={refreshMapAndTable}
              />
            </Col>
          )}
          {
            <ZoneMoveModal
              stores={selectedRegionsAndStoresConfig?.stores}
              setZoneMoveModalConfig={setZoneMoveModalConfig}
              zoneMoveModalConfig={zoneMoveModalConfig}
              shipmentTypes={shipmentTypes}
              onSuccessCallback={refreshMapAndTable}
            />
          }
          {generateSlot && (
            <GenerateSlot
              dataItem={dataItemForSlots}
              onCloseHandler={() => setGenerateSlot(false)}
            />
          )}
        </Suspense>
      </div>
      <Row style={{ marginTop: '10px' }}>
        <Row gutter={10} style={{ width: '100%' }}>
          <Col span={collapsed ? 12 : 0}>
            <Menu
              mode="inline"
              inlineCollapsed={collapsed}
              style={{ width: '100%', background: '#f0f2f5' }}
            >
              <>
                <SelectRegionsAndStores
                  setSelectedRegionsAndStoresConfig={
                    setSelectedRegionsAndStoresConfig
                  }
                  isDrawingEnabled={isDrawingEnabled}
                />
                <Row>
                  {
                    !zoneState?.isAddOpen &&
                    !zoneState?.isEditOpen && (
                      <ConfigProvider locale={trTR}>
                        <Table
                          style={{ width: '100%' }}
                          size="small"
                          columns={columns}
                          dataSource={geoRadarZones.map((item, index) => ({
                            ...item,
                            key: index.toString(),
                          }))}
                          pagination={tableParams.pagination}
                          loading={loading}
                          onChange={handleTableChange}
                          expandable={{
                            expandedRowRender,
                            expandIcon: ({ expanded, onExpand, record }) =>
                              expanded ? (
                                <UpCircleOutlined
                                  onClick={(e) => onExpand(record, e)}
                                />
                              ) : (
                                <DownCircleOutlined
                                  onClick={(e) => onExpand(record, e)}
                                />
                              ),
                            expandedRowKeys: zoneState?.activeExpZoneRow,
                            onExpand: (expanded, record) => {
                              const keys = [];
                              setLoading(true);
                              setZoneVersionData({
                                versionsData: [],
                                zoneId: null,
                              });
                              setSelectedRowsForVersionHistoryTable(null);
                              if (expanded) {
                                keys.push(record.id);
                                getGeoRadarZoneHistory(record.id)
                                  .then((getHistory) => {
                                    if (
                                      getHistory !== null &&
                                      getHistory !== undefined
                                    ) {
                                      setZoneVersionData({
                                        versionsData: getHistory.data,
                                        zoneId: record.id,
                                      });
                                    }
                                  })
                                  .finally(() => setLoading(false));
                              } else {
                                setLoading(false);
                              }
                              setActiveExpZoneRow(keys);
                            },
                          }}
                          rowKey={(record) => record.id}
                          scroll={{
                            y: '70vh',
                          }}
                          rowSelection={{
                            ...rowSelection,
                            hideSelectAll: true,
                          }}
                        />
                      </ConfigProvider>
                    )}
                </Row>
                <div>
                  <Suspense fallback={<></>}>
                    {zoneState?.isAddOpen && (
                      <Col>
                        <Add
                          isHaveCentralRole={isHaveCentralRole}
                          zoneTypes={zoneTypes}
                          zonesAllInfo={geoRadarZones}
                          stores={selectedRegionsAndStoresConfig?.stores}
                          onSuccessCallback={refreshMapAndTable}
                          shipmentTypes={shipmentTypes}
                          isCrudEnabled={isCrudEnabled}
                        />
                      </Col>
                    )}
                    {zoneState?.isEditOpen && (
                      <Edit
                        isHaveCentralRole={isHaveCentralRole}
                        onSuccessCallback={refreshMapAndTable}
                        shipmentTypes={shipmentTypes}
                        isCrudEnabled={isCrudEnabled}
                      />
                    )}
                    {zoneState?.isFiltersOpen && (
                      <ZonesTableFilters
                        setFilters={setFilters}
                        form={form}
                        zoneTypes={zoneTypes}
                      />
                    )}
                  </Suspense>
                </div>
              </>
            </Menu>
          </Col>
          <Col span={collapsed ? 12 : 24} style={{ position: 'relative' }}>
            <Form name="number">
              <Form.Item
                style={{
                  position: 'absolute',
                  top: '14px',
                  left: '200px',
                  width: 300,
                  zIndex: '10',
                }}
                name="number"
                rules={[
                  {
                    pattern: new RegExp('^[0-9,.]+$'),
                    message: t('locationWarningMessage'),
                  },
                ]}
              >
                <Search
                  placeholder={t('enterLocation')}
                  allowClear
                  onSearch={onSearch}
                />
              </Form.Item>
            </Form>
            <MapOperations
              zonesAllInfo={geoRadarZones}
              selectedRowsForVersionHistoryTable={
                selectedRowsForVersionHistoryTable
              }
              refreshMap={refreshMap}
              selectedCityDistrictOrNeighborhoodConfig={
                selectedCityDistrictOrNeighborhoodConfig
              }
              customerLocation={customerLocation}
              setSelectedRowKeys={setSelectedRowKeys}
              selectedRowKeys={selectedRowKeys}
            ></MapOperations>
          </Col>
        </Row>
      </Row>
      {zoneState?.heatmapToggle && heatmapModalOpen && (
        <OrderHeatmapLayer
          setHeatmapModalOpen={setHeatmapModalOpen}
          setHeatmapChecked={setHeatmapChecked}
          heatmapForm={heatmapForm}
        />
      )}
    </div>
  );
};

export default connect()(Zones);
